<ng-container *permission="'create.companyEmployee'">
    <ui-dialog
        header="employees.directory.whatWouldYouLikeToDo"
        [open]="isCreateEmployeeDialogOpen"
        (closing)="isCreateEmployeeDialogOpen = false"
    >
        <div class="create-employee-buttons">
            <ui-card
                variant="outline"
                [centered]="true"
                [clickable]="true"
                (click)="onSendOffer()"
                [withMargin]="false"
            >
                <h3 class="margin-bottom-1">{{ 'employees.directory.sendOffer' | appTranslate }}</h3>
                {{ 'employees.directory.sendAnOfferLetter' | appTranslate }}
            </ui-card>
            <ui-card variant="outline" [centered]="true" [clickable]="true" (click)="onNewHire()" [withMargin]="false">
                <h3 class="margin-bottom-1">{{ 'employees.directory.hireEmployee' | appTranslate }}</h3>
                {{ 'employees.directory.onboardNewEmployee' | appTranslate }}
            </ui-card>
            <ui-card
                variant="outline"
                [centered]="true"
                [clickable]="true"
                routerLink="create-terminated"
                [withMargin]="false"
            >
                <h3 class="margin-bottom-1">{{ 'employees.directory.terminatedEmployee' | appTranslate }}</h3>
                {{ 'employees.directory.addTerminatedEmployee' | appTranslate }}
            </ui-card>
        </div>
    </ui-dialog>
</ng-container>

<div class="page-container no-scroll" [class.loading]="isLoading">
    <app-header title="{{ 'employees.directory.people' | translate }}" [menuService]="employeeModuleMenuService">
        <div class="buttons">
            <ui-button type="primary" (click)="onCreate()" *ngIf="hasHiringPermissions">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'employees.directory.employee' | translate }}
            </ui-button>
        </div>
    </app-header>
    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            *ngIf="table"
            [table]="table"
            [isResponsive]="true"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <app-empty-state
                label="{{ 'employees.directory.noEmployeesFound' | translate }}"
                src="/assets/illustrations/magnifying-glass.png"
            >
            </app-empty-state>
        </app-table>
    </ui-card>
</div>
